import { render, staticRenderFns } from "../templates/milkInspection.pug?vue&type=template&id=10733dd0&scoped=true&lang=pug&"
import script from "./MilkInspection.vue?vue&type=script&lang=js&"
export * from "./MilkInspection.vue?vue&type=script&lang=js&"
import style0 from "./MilkInspection.vue?vue&type=style&index=0&id=10733dd0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10733dd0",
  null
  
)

export default component.exports